import { TRACKING_CONFIG } from '../../utils/configure-environment';
import isMobile from '../../utils/is-mobile';

const Creator = 'Creator';
const { siteTypeLevel, language, country, anonymizeIP } = TRACKING_CONFIG;
const trackingEnabled = !!siteTypeLevel && !!language && !!country;

export const elementTypeToTrackingName = elementType => {
  switch (elementType) {
    case 'upload':
      return 'Picture';
    case 'design':
      return 'Motif';
    default:
      return elementType.charAt(0).toUpperCase() + elementType.slice(1);
  }
};

export const TrackingMixin = {
  methods: {
    trackEvent({ category = Creator, action, label, value }) {
      trackingEnabled &&
        this.$gtm.trackEvent({
          event: 'uaevent',
          creatorVariant: isMobile() ? 'mobile' : 'desktop',
          eventCategory: category,
          eventAction: action,
          eventLabel: label,
          eventValue: value,
          siteTypeLevel,
          language,
          country,
          anonymizeIP
        });
    },
    trackPath({
      virtPath,
      virtTitle,
      contentGroup1 = Creator,
      contentGroup2,
      contentGroup3
    }) {
      trackingEnabled &&
        this.$gtm.trackEvent({
          event: 'virtPath',
          creatorVariant: isMobile() ? 'mobile' : 'desktop',
          virtPath,
          virtTitle,
          contentGroup1,
          contentGroup2,
          contentGroup3,
          siteTypeLevel,
          language,
          country,
          anonymizeIP
        });
    }
  }
};
